import styled from 'styled-components';

export const Placeholder = styled.div`
  position: relative;
  width: 88px;
  height: 88px;
  background-repeat: no-repeat;
  background-size: 100%;
  margin: 24px auto;
`;

export const CardButton = styled.button`
  background: none;
  border: 0;
  cursor: pointer;
  outline: 0;
  padding: 0;
  text-decoration: none;
  width: 100%;
`;

export const CardAction = styled.div`
  color: #404040;
  font-size: 14px;
  display: flex;
  justify-content: center;

  .actionCtn {
    flex: 1 0;
    padding: 0 20px;
  }
`;

export const Exception = styled.span`
  margin-left: -30px;
`;

export const Contributions = styled.span`
  margin-left: 0px;
`;

export const NotificationIcon = styled.i`
  position: absolute;
  top: -22px;
  right: -8px;
  font-size: 24px;
  color: ${props => props.theme.color[props.variant]};
`;

export const Card = styled.div`
  width: 100%;
  box-sizing: border-box;
  position: relative;
`;



// WEBPACK FOOTER //
// ./src/features/fbt/driver/components/NitroCard/styles.js